/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useContext } from 'react';
import { IConfigTransparency, IConfigurationValues, IConfigVisibility } from './use-map-context-hook';
import { IRecordMap } from '../../../../store/modules/report/i-report';
import { IMapViewState } from '../../../../store/modules/facility/i-facility';

interface IMapContext {
  selectedPin:IRecordMap | null;
  selectedPinIconUrl:string | null;
  onSelectPin:(item:IRecordMap | null)=>void
  showAssetDetails:boolean
  onShowAssetDetails:(item:IRecordMap | null)=>void
  onCloseAssetDetails:()=>void
  onPinButtonClick:()=>void
  onMapButtonClick:()=>void
  onClusterClick:(cluster:IRecordMap[])=>void
  onSkipSelectedGroup:()=>void
  onConfigurationDrawerHandler:()=>void
  openConfigurationDrawer:boolean
  onImageButtonClick:()=>void
  flyToMarker:(X:number, Y:number, uniqueKey:string)=>void
  mapRef:any
  clusterGroupRef:any
  configurationValues:IConfigurationValues
  setConfigurationsValues:(value:IConfigurationValues)=>void
  updatePageSize: (value: number) => void;
  updatePopupFields: (key: string, checked: boolean, seed: string[]) => void;
  setAllPopupFields: (fields: string[]) => void;
  setPageSize:(value:number)=>void
  skip:number
  setSkip:(value:number)=>void
  pageSizeOptions:string[]
  onAntenaButtonClick:()=>void
  onZoneButtonClick:()=>void
  saveControlsStateHandler:()=>void
  updateVisibilityValue:(key:keyof IConfigVisibility, value:boolean)=>void
  updateTransparencyValue:(key:keyof IConfigTransparency, value:number)=>void
  onXYAxesButtonClick:()=>void
  onLLAxesButtonClick:()=>void
  dimensions:{ width:number, height:number } | null
  imageAngle:number
  setImageAngle:(value:number)=>void
  collapseAssetBar:boolean
  onCollapseAssetBar:()=>void
  rangePerDegree:{lon:number, lat:number}
  rotatePoint:(point:[number, number], center:[number, number], angle:number)=>[number, number]
  rangeToCoordinates:(rangeX:number, rangeY:number)=>[number, number] | null
  setPinDigits:(value:number)=>void
  pinDigits:number
  isConfigurationUpdated:boolean
  setOpenConfigurationDrawer:(value:boolean)=>void
  rotateMapPerAzimuth: () => void;
  resetMapRotation: () => void;
  hasAssetFilter: boolean;
  facilityKey: string;
  savedViewState?: IMapViewState;
}

export const MapContext = createContext({} as IMapContext);

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useMapContext = () => useContext(MapContext);
